import { convertLinkedInTextToJSON } from "../../utils/editor-parser.js";

export const createPublishPostRequest = (post, async = true) => {
    let id = post.id;
    return {
        url: "/posts/" + id + "/publish",
        method: "POST",
        data: {
            async: async,
        },
        disableLoading: true,
    };
}

export const createGetPostRequest = (id, disableLoading = false) => {
    return {
        url: "/posts/" + id,
        method: "GET",
        disableLoading: disableLoading,
    };
}

export const createGetKanbanPostsRequest = () => {
    return {
        url: "/kanban/",
        method: "GET",
    };
}

export const createGetKanbanPostsByStatusRequest = (page = 1, per_page = 5, status = "under_review") => {
    return {
        url: `/kanban/${status}`,
        method: "GET",
        params: {
            page,
            per_page,
        },
    };
}

export const createSaveDraftRequest = (post) => {
    let text = post.text;
    let media_ids = post.media_ids || [];
    // Forward legacy URL fields alongside media_ids so pre-migration media
    // (records without linked MediaItem rows) is preserved on save.
    let image_urls = post.image_urls || [];
    let video_url = post.video_url || null;
    let file_url = post.file_url || null;
    let mentions = post.mentions;
    let rich_text = post.richText;
    let linked_in_account_id = post.linked_in_account_id;
    if (rich_text === undefined || rich_text === null || rich_text === "") {
        rich_text = convertLinkedInTextToJSON(text);
    }
    let carousel_title = post.carousel_title;
    let video_title = post.video_title;
    let video_thumbnail_url = post.video_thumbnail_url;
    let tags = post.tags;
    let show_link_preview= post.show_link_preview
    let link_preview_data = post.link_preview_data;
    let source = post.source;

    return {
        url: "/posts",
        method: "POST",
        data: {
            text,
            media_ids,
            image_urls,
            video_url,
            file_url,
            mentions,
            rich_text,
            carousel_title,
            linked_in_account_id,
            video_title,
            video_thumbnail_url,
            tags,
            show_link_preview,
            link_preview_data,
            source,
        },
    };
}
export const createUpdatePostRequest = (post) => {
    const {
        id,
        text,
        mentions,
        richText,
        carousel_title,
        linked_in_account_id,
        linked_in_account,
        video_title,
        video_thumbnail_url,
        tags,
        publish_from_type,
        linked_in_company_page_id,
        show_link_preview,
        link_preview_data,
        source
    } = post;
    let media_ids = post.media_ids || [];
    let image_urls = post.image_urls || [];
    let video_url = post.video_url || null;
    let file_url = post.file_url || null;

    return {
        url: `/posts/${id}`,
        method: "PUT",
        data: {
            text,
            media_ids,
            image_urls,
            video_url,
            file_url,
            mentions,
            rich_text: richText,
            carousel_title,
            linked_in_account_id,
            linked_in_account,
            video_title,
            video_thumbnail_url,
            tags,
            publish_from_type,
            linked_in_company_page_id,
            show_link_preview,
            link_preview_data,
            source
        },
    };
};

export const createDeletePostRequest = (id) => {
    return {
        url: "/posts/" + id,
        method: "DELETE",
    };
}

export const createGetPostsByStatusRequest = (status, page, per_page, tag_ids) => {
    return {
        url: "/posts",
        method: "GET",
        params: {
            status,
            page,
            per_page,
            tag_ids
        },
    };
}

export const createGetPostsCountGroupedByStatusRequest = (tag_ids) => {
    return {
        url: `/posts/count${tag_ids ? `?tag_ids=${tag_ids}` : ""}`,
        method: "GET",
    };
}

export const createGetPostTagsRequest = () => {
    return {
        url: "/tags",
        method: "GET"
    }
}

export const createGetUpdateTagsRequest = (id, name) => {
    return {
        url: `/tags/${id}`,
        method: "PUT",
        data: {
            name
        }
    }
}

export const createSavePostTagRequest = (name) => {
    return {
        url: "/tags",
        method: "POST",
        data: {
            name
        }
    }
}

export const createConvertFailedPostToDraftRequest = (id) => {
    return {
        url: "/posts/" + id + "/convert_failed_post_to_draft",
        method: "POST",
    };
}

export const createEnablePublicPostLinkRequest = (id) => {
    return {
        url: "/posts/" + id + "/public_link",
        method: "POST",
        data: {
            enable_public_feedback_comments: true,
        }
    }
}

export const createDisablePublicPostLinkRequest = (id) => {
    return {
        url: "/posts/" + id + "/public_link",
        method: "DELETE"
    }
}

export const createEnablePublicPostFeedbackRequest = (id) => {
    return {
        url: "/posts/" + id + "/public_link",
        method: "POST",
        data: {
            enable_public_feedback_comments: true,
        }
    }
}

export const createDisablePublicPostFeedbackRequest = (id) => {
    return {
        url: "/posts/" + id + "/public_link",
        method: "POST",
        data: {
            enable_public_feedback_comments: false,
        }
    }
}

export const createPostFeedbackRequest = (postId, feedback_text, post_text) => {
    return {
        url: `/posts/${postId}/feedback_comments/`,
        method: "POST",
        data: {
            feedback_text,
            post_text,
        },
    };
}

export const createGetPostFeedbackRequest = (postId, per_page, page) => {
    return {
        url: `/posts/${postId}/feedback_comments`,
        method: "GET",
        params: {
            per_page,
            page
        },
    };
}

export const createSendPostForApprovalRequest = ({postId, approver_user_id, review_message}) => {
    return {
        url: `/posts/${postId}/approval/request`,
        method: "POST",
        data: {
            approver_user_id,
            review_message,
        },
    };
}

export const createGetPostPendingApprovalRequest = (postId) => {
    return {
        url: `/posts/${postId}/approval/request`,
        method: "GET",
    };
}

export const createCancelPostSentForApprovalRequest = ({postId, post_review_id}) => {
    return {
        url: `/posts/${postId}/approval/request/${post_review_id}/cancel`,
        method: "POST",
    };
}

export const createApprovePostRequest = ({postId, post_review_id, approver_notes}) => {
    return {
        url: `/posts/${postId}/approval/request/${post_review_id}/approve`,
        method: "POST",
        data: {
            "approver_notes": approver_notes,
        },
    };
}

export const createRejectPostRequest = ({postId, post_review_id, approver_notes}) => {
    return {
        url: `/posts/${postId}/approval/request/${post_review_id}/reject`,
        method: "POST",
        data: {
            "approver_notes": approver_notes,
        },
    };
}

export const createUpdatePostStatusRequest = (postId, toColumnId) => {
    return {
        url: `/posts/${postId}/status`,
        method: "PUT",
        data: {
            status: toColumnId,
        },
    };
}

export const createBulkUploadPostsRequest = (posts) => {
    return {
        url: "/posts/bulk",
        method: "POST",
        data: {
            posts,
        },
    };
}

export const createGetReviewersRequest = () => ({
    url: "/posts/reviewers",
    method: "GET",
});

export const createBulkSendForApprovalRequest = (posts, approverUserId) => ({
  url: "/posts/bulk_approval/request",
  method: "POST",
  data: { posts, approver_user_id: approverUserId },
});

export const createBulkDeletePostsRequest = (postIds) => ({
  url: "/posts/bulk_delete",
  method: "POST",
  data: { post_ids: postIds },
});

export const createUnfurlUrlRequest = (url) => {
    return {
        url: "/posts/unfurl",
        method: "POST",
        data: {
            url: url,
        },
        disableLoading: true,
    };
}
